<template>
  <w-flex class="form-aside" direction="col" align="stretch">
    <w-flex class="form-aside__logo" justify="center">
      <img src="../../assets/witkac_generator_biale.png" />
    </w-flex>

    <w-flex v-if="documentTitle" class="form-aside__document-title-wrapper">
      <h1 class="form-aside__document-title-wrapper__document-title">
        {{ documentTitle }}
      </h1>
    </w-flex>

    <w-flex fluid direction="col" class="form-aside__tab-list w-scroll">
      <form-aside-button
        v-for="(tab, index) in tabs"
        :key="'tab_' + tab.name + '_' + index"
        :tab="tab"
        :index="index"
        :active="currentTabName == tab.name"
        @tab-selected="$emit('change-tab', tab)"
      />
    </w-flex>

    <w-flex v-if="projectNameAndVersion" class="form-aside__version" justify="center">
      {{ projectNameAndVersion }}
    </w-flex>
  </w-flex>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { Tab } from '@/typings/tab';

import FormAsideButton from './FormAsideButton.vue';

const props = defineProps<{
  tabs: Tab[];
  version?: string;
  projectName?: string;
  documentTitle?: string;
  currentTabName: string;
}>();

const projectNameAndVersion = computed(() =>
  [props.projectName, props.version].filter(Boolean).join(' / '),
);
</script>

<style lang="scss">
.form-aside {
  background: w.color('neutral', 900);
  width: w.size('aside-width');
  flex-shrink: 0;
  flex-grow: 0;

  &__tab-list,
  &__version,
  &__document-title-wrapper {
    border-top: solid 1px w.color('neutral', 800);

    &__document-title {
      font-size: w.font('large');
      font-weight: w.weight('medium');
      color: w.color('text-reverse');
      padding: 12px w.size('layout-padding');
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
  }

  hr {
    border-color: w.color('neutral', 800);
  }

  &__logo {
    max-width: 100%;
    margin: 10px 0;

    img {
      width: 100%;
      max-width: w.size('logo-max-width');
      object-fit: contain;
    }
  }

  &__tab-list {
    border-bottom: solid 1px w.color('neutral', 800);
    border-top: solid 1px w.color('neutral', 800);
    height: 0;
    overflow: auto;
  }

  &__version {
    padding: 12px w.size('layout-padding');
    color: w.color('neutral', 500);
    font-size: w.font('xxsmall');
    text-align: center;
    letter-spacing: 0.1em;
  }
}
</style>
